import {
  JOIN_EDIT, JOIN_EDIT_FAILURE, JOIN_EDIT_SUCCESS, JOIN_UPDATE, JOIN_UPDATE_FAILURE, JOIN_UPDATE_SUCCESS
} from './mutation-types'

export default {
  state: {
    join: null
  },
  getters: {
    join: state => {
      return state.join
    }
  },
  actions: {
    [JOIN_EDIT] ({dispatch, state, commit}, params = null) {
      var data = params.data
      var callback = null
      if (data) {
        callback = data.callback
      }
      var url = '/master/joins/' + params.id
      dispatch('apiGet', {url: url, data: {id: params.id}, loadparams: true})
        .then(res => {
          if (res.status === 200 || res.status === 304) {
            if (res.data.error) {
              commit(JOIN_EDIT_FAILURE, res.data)
            } else {
              res.data.callback = callback
              commit(JOIN_EDIT_SUCCESS, res.data)
            }
          }
        })
        .catch(error => {
          throw error
        })
    },
    [JOIN_UPDATE] ({dispatch, state, commit}, params = null) {
      var data = params.data
      var url = '/master/joins/' + params.id
      dispatch('apiPatch', {url: url, data: data})
        .then(res => {
          if (res.status === 200 || res.status === 304) {
            if (res.data.error) {
              commit(JOIN_UPDATE_FAILURE, res.data)
            } else {
              commit(JOIN_UPDATE_SUCCESS, { data: res.data, callback: params.callback })
            }
          }
        })
        .catch(error => {
          throw error
        })
    }
  },
  mutations: {
    [JOIN_EDIT_FAILURE] (state, data) {
      console.log('JOIN_EDIT_FAILURE')
    },
    [JOIN_EDIT_SUCCESS] (state, data) {
      console.log('JOIN_EDIT_SUCCESS')
      state.join = data
      if (data.callback) {
        data.callback()
      }
    },
    [JOIN_UPDATE_FAILURE] (state, data) {
      console.log('JOIN_UPDATE_FAILURE')
    },
    [JOIN_UPDATE_SUCCESS] (state, data) {
      console.log('JOIN_UPDATE_SUCCESS')
      var callback = data.callback
      callback()
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/join-edit.js